export enum PriorityQueryKey {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum TypeQueryKey {
  Viewer = 'viewer',
  Count = 'count',
  Color = 'color',
}
